import { createFileRoute, useParams } from "@tanstack/react-router";
import { queryClient, trpc } from "~/utils/trpc";
import { ClientDetailsPage } from "./clients/-pages/clientDetails";
import { z } from "zod";
import { useBreadCrumbs } from "~/contexts/useBreadCrumbs";
import { sanitizeDocumentTitlePart, useDocumentTitle } from "~/utils/document-title";

const clientDetailSearchSchema = z.object({
  view: z
    .enum([
      "details",
      "jobs",
      "applications",
      "notes",
      "activity",
      "communications",
      "placements",
      "documents",
      "chat-projects",
    ])
    .optional()
    .default("details"),
});

export const Route = createFileRoute("/_dashboard/$datasetSlug/data/clients/$clientId")({
  staleTime: 0,
  validateSearch: clientDetailSearchSchema,
  loader: async ({ params }) => {
    const [client] = await Promise.all([
      queryClient.fetchQuery(trpc.clients.getClientById.queryOptions({ id: params.clientId })),
      queryClient.prefetchQuery(trpc.clientsSettings.get.queryOptions()),
    ]);
    return { client };
  },
  component: ClientDetailsComponent,
});

function ClientDetailsComponent() {
  const { client } = Route.useLoaderData();
  const { datasetSlug } = useParams({ from: "/_dashboard/$datasetSlug" });
  const clientName = sanitizeDocumentTitlePart(client?.name, "Client");
  useDocumentTitle(clientName, "Client");

  useBreadCrumbs([
    { title: "Clients", link: `/${datasetSlug}/data/clients` },
    { title: clientName, link: `/${datasetSlug}/data/clients/${client?.id}` },
  ]);
  return <ClientDetailsPage client={client} />;
}
